import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
  StyledContainerFooterSideBar,
  StyledContainerItems,
  StyledTitleSideBar
} from '../../../components/commons/SideBarComponents/sideBarComponentsStyles';
import Strings from '../../../i18n';
import { SideBarEditablePropertyItem } from '../../../components/commons/SideBarComponents/EditablePropertyItem/sideBarEditablePropertyItem';
import { usePostUserInfoWithKeyMutation } from '../../../services/auth/authServices';
import { SideBarDeleteActionWithPopup } from '../../../components/commons/SideBarComponents/DeleteActionWithPopup/sideBarDeleteActionWithPopup';
import { useDeleteUsersPendingActivationMutation } from '../../../services/users/usersService';
import { IUserPendingActivation } from '../../../types/users';

interface ActivateUserSidebarProps {
  setOpenRightSideBar: (open: boolean) => void;
  selectedItem: IUserPendingActivation;
  reloadTable: () => void;
}
export const ActivateUserSidebar = ({
  setOpenRightSideBar,
  selectedItem,
  reloadTable
}: ActivateUserSidebarProps) => {
  const [activateUser, { isSuccess, isLoading }] =
    usePostUserInfoWithKeyMutation();

  const [
    deleteUsersPendingActivation,
    { isSuccess: isDeleteSuccess, isLoading: isDeleteLoading }
  ] = useDeleteUsersPendingActivationMutation();

  const [activationInfo, setActivationInfo] = useState<{
    email: string;
    phoneNumber: string;
    password: string;
    firstName: string;
    lastName: string;
    key: string;
    sendInvitationEmail: boolean;
  }>({
    email: '',
    password: '1234',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    key: '',
    sendInvitationEmail: false
  });

  const handleActivateUser = () => {
    activateUser({
      ...activationInfo,
      email: selectedItem?.email,
      key: selectedItem?.key
    });
  };
  const deleteUsers = () => {
    deleteUsersPendingActivation([selectedItem?.id]);
  };
  useEffect(() => {
    if (isSuccess) {
      setOpenRightSideBar(false);
      toast.success(Strings.users.successActivateUser);
      reloadTable();
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isDeleteSuccess) {
      toast.success(Strings.users.usersDeletedSuccessfully);
      setOpenRightSideBar(false);
      reloadTable();
    }
  }, [isDeleteSuccess]);

  useEffect(() => {
    setActivationInfo({
      ...activationInfo,
      email: selectedItem?.email,
      key: selectedItem?.key
    });
  }, [selectedItem]);

  return (
    <>
      <StyledContainerItems>
        <StyledTitleSideBar>{Strings.users.activateUser}</StyledTitleSideBar>
        <SideBarEditablePropertyItem
          item={{
            label: Strings.common.email,
            currentValue: activationInfo?.email,
            type: 'text',
            nameAndId: 'email',
            disabled: true,
            onChange: (e) => {
              setActivationInfo({ ...activationInfo, email: e.target.value });
            }
          }}
        />
        <SideBarEditablePropertyItem
          item={{
            label: Strings.users.firstName,
            currentValue: activationInfo?.firstName,
            type: 'text',
            nameAndId: 'firstName',
            onChange: (e) => {
              setActivationInfo({
                ...activationInfo,
                firstName: e.target.value
              });
            }
          }}
        />
        <SideBarEditablePropertyItem
          item={{
            label: Strings.users.lastName,
            currentValue: activationInfo?.lastName,
            type: 'text',
            nameAndId: 'lastName',
            onChange: (e) => {
              setActivationInfo({
                ...activationInfo,
                lastName: e.target.value
              });
            }
          }}
        />
        <SideBarEditablePropertyItem
          item={{
            label: Strings.users.password,
            currentValue: activationInfo.password,
            type: 'text',
            nameAndId: 'password',
            onChange: (e) => {
              setActivationInfo({
                ...activationInfo,
                password: e.target.value
              });
            }
          }}
        />
        <SideBarDeleteActionWithPopup
          onDelete={() => deleteUsers()}
          titleConfirmation={Strings.users.deleteUsersTitle}
          textConfirmation={Strings.common.thisActionIsIrreversible}
          textIcon={
            isDeleteLoading ? Strings.common.loading : Strings.users.deleteUsers
          }
        />
      </StyledContainerItems>

      <StyledContainerFooterSideBar>
        <button
          type="button"
          className="btn-cancel"
          onClick={() => {
            setOpenRightSideBar(false);
          }}
        >
          {Strings.common.cancel}
        </button>
        <button
          type="button"
          className="btn-save"
          onClick={handleActivateUser}
          disabled={
            isLoading ||
            !activationInfo.password ||
            !activationInfo.firstName ||
            !activationInfo.lastName
          }
        >
          {isLoading ? Strings.common.loading : Strings.common.save}
        </button>
      </StyledContainerFooterSideBar>
    </>
  );
};
